import { formatNumberV2 } from "helpers/commonHelpers";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";

export default function SubCommodity({ row }: any) {
  const intl = useIntl();

  const {
    handling_unit,
    other_instructions,
    additional_field_label,
    container_type,
    length,
    width,
    height,
    m_unit,
    units,
    weight,
    w_unit,
    hazardous,
    is_dangerous_good,
    dangerous_good_value,
    temperature_control_required,
    temperature_control_value,
    stackable,
    crating_required,
    additional_information,
    handling_required,
    good_customs_information,
  } = row.original;

  const yesMesssage = intl.formatMessage({
    id: "general.yes",
    defaultMessage: "Yes",
  });
  const noMessage = intl.formatMessage({
    id: "general.no",
    defaultMessage: "No",
  });

  const commodityData = [
    {
      name: intl.formatMessage({
        id: "quotation-form.viewCommodities.handlingUnit",
        defaultMessage: "Handling unit",
      }),
      value: <p className="text-capitalize mb-0">{handling_unit}</p>,
    },
    ...(other_instructions
      ? [
          {
            name:
              additional_field_label ||
              intl.formatMessage({
                id: "new-request.packing-list.otherInstructions",
                defaultMessage: "Other instructions",
              }),
            value: other_instructions,
          },
        ]
      : []),
    ...(container_type
      ? [
          {
            name: intl.formatMessage({
              id: "quotation-form.viewCommodities.containerType",
              defaultMessage: "Container type",
            }),
            value: <p className="text-capitalize mb-0">{container_type}</p>,
          },
        ]
      : []),
    {
      name: intl.formatMessage({
        id: "quotation-form.viewCommodities.size",
        defaultMessage: "Size (L x W x H)",
      }),
      value: `${length || 0} x ${width || 0} x ${height || 0} ${m_unit}`,
    },
    {
      name: intl.formatMessage({
        id: "quotation-form.viewCommodities.units",
        defaultMessage: "Units",
      }),
      value: units,
    },
    {
      name: intl.formatMessage({
        id: "quotation-form.viewCommodities.unitWeight",
        defaultMessage: "Unit weight",
      }),
      value: `${weight} ${w_unit}`,
    },
    {
      name: intl.formatMessage({
        id: "quotation-form.viewCommodities.totalWeight",
        defaultMessage: "Total weight",
      }),
      value: `${weight * units} ${w_unit}`,
    },
    {
      name: intl.formatMessage({
        id: "quotation-form.viewCommodities.hazardous",
        defaultMessage: "Hazardous",
      }),
      value: hazardous ? yesMesssage : noMessage,
    },
    {
      name: intl.formatMessage({
        id: "quotation-form.viewCommodities.dangerous",
        defaultMessage: "Dangerous",
      }),
      value: is_dangerous_good ? dangerous_good_value : noMessage,
    },
    ...(temperature_control_required
      ? [
          {
            name: intl.formatMessage({
              id: "quotation-form.viewCommodities.temperatureControl",
              defaultMessage: "Temperature control",
            }),
            value: temperature_control_value || "-",
          },
        ]
      : []),
    {
      name: intl.formatMessage({
        id: "quotation-form.viewCommodities.stackable",
        defaultMessage: "Stackable",
      }),
      value: stackable ? yesMesssage : noMessage,
    },
    {
      name: intl.formatMessage({
        id: "quotation-form.viewCommodities.cratingRequired",
        defaultMessage: "Crating required",
      }),
      value: crating_required ? yesMesssage : noMessage,
    },
    {
      name: intl.formatMessage({
        id: "quotation-form.viewCommodities.additionalInformation",
        defaultMessage: "Additional information",
      }),
      value: additional_information || "-",
    },
    ...(handling_required !== null
      ? [
          {
            name: intl.formatMessage({
              id: "new-request.packing-list.handlingRequired",
              defaultMessage: "Handling required",
            }),
            value: handling_required ? yesMesssage : noMessage, // boolean only in case of multi-drop shipment
          },
        ]
      : []),
  ];

  return (
    <div className="" style={{ backgroundColor: "#F7F9FA" }}>
      <Row className="text-secondary font-b4 mb-3">
        <Col xs={4}>
          <FormattedMessage id="quotation-form.viewCommodities.name" defaultMessage="Name" />
        </Col>
        <Col>
          <FormattedMessage id="quotation-form.viewCommodities.requested" defaultMessage="Requested" />
        </Col>
      </Row>
      {commodityData.map((item, index) => (
        <Row key={index} className="mb-1">
          <Col className="font-b9" xs={4}>
            {item.name}
          </Col>
          <Col>{item.value}</Col>
        </Row>
      ))}
      {good_customs_information?.length > 0 &&
        good_customs_information.map((item: any, index: number) => (
          <div key={index} className="mb-1">
            <Row>
              <Col className="font-b9 col-4" xs={4}>
                {intl.formatMessage(
                  {
                    id: "quotation-form.viewCommodities.customsInformationHeading",
                    defaultMessage: "Customs Information {number}",
                  },
                  { number: index + 1 },
                )}
              </Col>
            </Row>
            {item.description && (
              <Row>
                <Col className="col-4">
                  <FormattedMessage
                    id="quotation-form.viewCommodities.commodityInformation"
                    defaultMessage="Commodity Information"
                  />
                </Col>
                <Col>{item.description}</Col>
              </Row>
            )}
            {item.hs_code && (
              <Row>
                <Col className="col-4">
                  <FormattedMessage id="quotation-form.viewCommodities.hsCode" defaultMessage="HS Code" />
                </Col>
                <Col>{item.hs_code}</Col>
              </Row>
            )}
            {item.value && (
              <Row>
                <Col className="col-4">
                  <FormattedMessage id="quotation-form.viewCommodities.value" defaultMessage="Value" />
                </Col>
                <Col>{`${item.value ? `${formatNumberV2(item.value)} ${item.currency_code}` : ""}`}</Col>
              </Row>
            )}
            {item.attachment?.url && (
              <Row>
                <Col className="col-4">
                  <FormattedMessage id="quotation-form.viewCommodities.attachment" defaultMessage="Attachment" />
                </Col>
                <Col>
                  <a href={item.attachment.url} target="_blank" rel="noreferrer">
                    {item.attachment.name}
                  </a>
                </Col>
              </Row>
            )}
          </div>
        ))}
    </div>
  );
}
